import React, { useState } from 'react';
import { getApiUrl } from 'api/helpers';
import { ApiRoutes } from 'types';
import { Button } from '@mui/material';
import { PowerSettingsNew } from '@mui/icons-material';
import { Dialog } from '../Dialog';

export const SupportModeDeactivateButton = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const onDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleImpersonationReset = () => {
    const body = document.getElementsByTagName('body')[0];
    if (!body) return;
    const tempForm = document.createElement('form');
    tempForm.method = 'POST';
    tempForm.action = getApiUrl({ path: ApiRoutes.ImpersonateReset });
    body.appendChild(tempForm);

    tempForm.submit();

    body.removeChild(tempForm);
  };

  return (
    <>
      <Button
        onClick={() => setIsDialogOpen(true)}
        variant="contained"
        startIcon={<PowerSettingsNew />}
        sx={{
          maxHeight: '32px',
          fontSize: '12px',
          fontWeight: 700,
          background: '#FFFFFF',
          color: (theme) => theme.palette.error.dark,
          px: 2,
          py: 1,
          '&:hover': {
            background: (theme) => theme.palette.error.light,
          },
        }}
      >
        Support-modus deaktivieren
      </Button>
      <Dialog
        title="Willst du den Support-Modus deaktivieren?"
        content=""
        open={isDialogOpen}
        onClose={onDialogClose}
        primaryActionTitle="Deaktivieren"
        onPrimaryActionClick={handleImpersonationReset}
        onSecondaryActionClick={onDialogClose}
      />
    </>
  );
};
